import React from 'react';

import { TAlertMessage } from '@/Utils/useAlertMessage';

export const AlertMessage = ({ type, title, description }: TAlertMessage) => {
  return (
    <div className={`flash ${type}`}>
      {title && <h4>{title}</h4>}

      <div className='message'>
        <p>{description}</p>
      </div>
    </div>
  );
};
